import styled from '@emotion/styled'

const Container = styled.section`
  & {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    flex-flow: column nowrap;
  }

  & > * {
    margin-bottom: 20px;
  }
`

export default Container
